import { render, staticRenderFns } from "./createProductLabelModel.vue?vue&type=template&id=77d86f93&scoped=true"
import script from "./createProductLabelModel.vue?vue&type=script&lang=js"
export * from "./createProductLabelModel.vue?vue&type=script&lang=js"
import style0 from "./createProductLabelModel.vue?vue&type=style&index=0&id=77d86f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d86f93",
  null
  
)

export default component.exports